// PickupPointsPage.js
import { useEffect, useState } from "react";
import api from "../services/api";

export default function PickupPointsPage() {
  const [points,  setPoints]  = useState([]);
  const [villes,  setVilles]  = useState([]);
  const [filter,  setFilter]  = useState("all");
  const [adding,  setAdding]  = useState(false);
  const [form,    setForm]    = useState({
    ville: "", nom: "", latitude: "", longitude: "", ordre: 1,
  });

  const fetchPoints = () =>
    api.get("/api/trips/pickup-points").then(res => {
      setPoints(res.data);
      const v = [...new Set(res.data.map(p => p.ville))].sort();
      setVilles(v);
    });

  useEffect(() => { fetchPoints(); }, []);

  const addPoint = async () => {
    if (!form.ville || !form.nom || !form.latitude || !form.longitude) {
      alert("Remplis tous les champs");
      return;
    }
    try {
      await api.post("/admin/pickup-points", form);
      setForm({ ville: "", nom: "", latitude: "", longitude: "", ordre: 1 });
      setAdding(false);
      fetchPoints();
    } catch (err) {
      console.error(err);
    }
  };

  const deletePoint = async (id) => {
    if (!window.confirm("Supprimer ce point ?")) return;
    try {
      await api.delete(`/admin/pickup-points/${id}`);
      fetchPoints();
    } catch (err) { console.error(err); }
  };

  const filtered = filter === "all" ? points : points.filter(p => p.ville === filter);

  return (
    <div style={{ padding: "1.5rem 0" }}>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>📍 Points de ramassage</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Gérez les points d'arrêt officiels</p>
        </div>
        <button onClick={() => setAdding(!adding)} style={{
          padding: "8px 16px", borderRadius: 8, border: "none",
          background: "#FFA500", color: "#fff", fontSize: 13,
          cursor: "pointer", fontWeight: 500,
        }}>
          ➕ Ajouter un point
        </button>
      </div>

      {/* Formulaire ajout */}
      {adding && (
        <div style={{ background: "#fff", borderRadius: 12, padding: 20, marginBottom: 16, border: "0.5px solid #e5e5e5" }}>
          <p style={{ fontSize: 14, fontWeight: 600, color: "#0B3C5D", marginBottom: 16 }}>Nouveau point de ramassage</p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 12 }}>
            {[
              ["ville",     "Ville",     "text",   "Saint-Louis"],
              ["nom",       "Nom",       "text",   "Gare routière"],
              ["latitude",  "Latitude",  "number", "16.0179"],
              ["longitude", "Longitude", "number", "-16.4896"],
              ["ordre",     "Ordre",     "number", "1"],
            ].map(([key, label, type, placeholder]) => (
              <div key={key}>
                <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 4 }}>{label}</label>
                <input
                  type={type}
                  placeholder={placeholder}
                  value={form[key]}
                  onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                  style={{
                    width: "100%", padding: "8px 12px", borderRadius: 8,
                    border: "0.5px solid #ddd", fontSize: 13,
                    boxSizing: "border-box",
                  }}
                />
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={addPoint} style={{
              padding: "8px 16px", borderRadius: 8, border: "none",
              background: "#0B3C5D", color: "#fff", fontSize: 13, cursor: "pointer",
            }}>💾 Sauvegarder</button>
            <button onClick={() => setAdding(false)} style={{
              padding: "8px 16px", borderRadius: 8,
              border: "0.5px solid #ccc", background: "#fff",
              fontSize: 13, cursor: "pointer",
            }}>Annuler</button>
          </div>
        </div>
      )}

      {/* Filtres villes */}
      <div style={{ display: "flex", gap: 8, marginBottom: "1.25rem", flexWrap: "wrap" }}>
        <button onClick={() => setFilter("all")} style={{
          fontSize: 13, padding: "6px 16px", borderRadius: 20, cursor: "pointer",
          border: "0.5px solid #ccc",
          background: filter === "all" ? "#0B3C5D" : "#fff",
          color:      filter === "all" ? "#fff"     : "#888",
        }}>Toutes</button>
        {villes.map(v => (
          <button key={v} onClick={() => setFilter(v)} style={{
            fontSize: 13, padding: "6px 16px", borderRadius: 20, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: filter === v ? "#0B3C5D" : "#fff",
            color:      filter === v ? "#fff"     : "#888",
          }}>{v}</button>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: "#fff", border: "0.5px solid #e5e5e5", borderRadius: 12, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#0B3C5D" }}>
            <tr>
              {["Ordre", "Ville", "Nom", "Latitude", "Longitude", "Actif", "Action"].map(h => (
                <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontSize: 12, fontWeight: 500, color: "#fff" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map(p => (
              <tr key={p.id} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
                <td style={{ padding: "12px 14px" }}>
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 6, background: "#f0f0f0", color: "#888" }}>
                    {p.ordre}
                  </span>
                </td>
                <td style={{ padding: "12px 14px", fontSize: 13, fontWeight: 500, color: "#0B3C5D" }}>{p.ville}</td>
                <td style={{ padding: "12px 14px", fontSize: 13, color: "#555" }}>{p.nom}</td>
                <td style={{ padding: "12px 14px", fontSize: 12, color: "#888" }}>{Number(p.latitude).toFixed(4)}</td>
                <td style={{ padding: "12px 14px", fontSize: 12, color: "#888" }}>{Number(p.longitude).toFixed(4)}</td>
                <td style={{ padding: "12px 14px" }}>
                  <span style={{
                    fontSize: 11, padding: "2px 8px", borderRadius: 20,
                    background: p.actif ? "#EAF3DE" : "#FCEBEB",
                    color:      p.actif ? "#3B6D11"  : "#A32D2D",
                  }}>
                    {p.actif ? "✅ Actif" : "⛔ Inactif"}
                  </span>
                </td>
                <td style={{ padding: "12px 14px" }}>
                  <button onClick={() => deletePoint(p.id)} style={{
                    fontSize: 12, padding: "5px 10px", borderRadius: 6,
                    border: "none", background: "#FCEBEB", color: "#A32D2D", cursor: "pointer",
                  }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}